export default __webpack_public_path__ + "static/media/beetle3.625736cd.jpg";